export const USER_LOGIN_REQUSET="USER_LOGIN_REQUSET"
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL="USER_LOGIN_FAIL"